import { create } from 'zustand';

export type UseLoadingStore = {
	loadingRows: { rows: string[], columns: string[] }
	setLoadingRows: (newValues: { rows: string[], columns: string[] }) => void
};

const useLoadingRowsStore = create<UseLoadingStore>()((set) => ({
	loadingRows:    { rows: [], columns: [] },
	setLoadingRows: (newValues) => {
		set({
			loadingRows: newValues,
		});
	},
}));

export default useLoadingRowsStore;
